










import { Component, Vue } from "vue-property-decorator";
import AuthTab, { AuthTabItem } from "@/containers/AuthTab.vue";
import {
  USER_ONE_DATA,
  UserData,
  UserOneVariables
} from "@/graphql/query/user/one";

@Component({
  components: {
    AuthTab
  },
  apollo: {
    user: {
      query: USER_ONE_DATA,
      variables(): UserOneVariables {
        return {
          userId: this.$apollo.vm.$route.params.userId
        };
      }
    }
  }
})
export default class TabFrame extends Vue {
  user: UserData | null = null;

  get tabItems(): AuthTabItem[] {
    const resourceId = this.$route.params.groupId;
    return [
      {
        name: "group-user-details",
        title: "ユーザー情報",
        scopes: [{ resource: "Group", resourceId, action: "management" }]
      }
    ];
  }
}
